import React from 'react';
import { useTranslation } from 'react-i18next';
import PageMeta from '../components/SEO/PageMeta';
import StructuredData from '../components/SEO/StructuredData';

const Imprint = () => {
    const { t } = useTranslation();
    // The useDocTitle hook is now replaced by the Helmet component

    const DetailItem = ({ label, value }) => (
        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4">
            <dt className="text-lg font-medium text-gray-500">{label}</dt>
            <dd className="mt-1 text-lg text-gray-900 sm:mt-0 sm:col-span-2">{value}</dd>
        </div>
    );

    return (
        <>
            <PageMeta
                title={t('imprint_page.doc_title')}
                description={t('imprint_page.meta_description')}
                path="/imprint"
            />
            <StructuredData type="page" page={{ name: t('imprint_page.title'), path: '/imprint', description: t('imprint_page.meta_description') }} />

            <div className="bg-white">
                <div className="max-w-4xl mx-auto py-16 sm:py-24 px-4">
                    <div className="text-center">
                        <h2 className="text-base font-semibold text-primary tracking-wide uppercase">{t('imprint_page.company_name_value')}</h2>
                        <h1 className="mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl">{t('imprint_page.title')}</h1>
                    </div>

                    <div className="mt-16 border-t border-gray-200 pt-8">
                        <dl className="divide-y divide-gray-200">
                            <DetailItem label={t('imprint_page.company_name_label')} value={t('imprint_page.company_name_value')} />
                            <DetailItem label={t('imprint_page.address_label')} value={t('imprint_page.address_value')} />
                            <DetailItem label={t('imprint_page.reg_number_label')} value={t('imprint_page.reg_number_value')} />
                            <DetailItem label={t('imprint_page.tax_number_label')} value={t('footer.company_info.tax_number_value')} />
                            <DetailItem label={t('imprint_page.hosting_provider_label')} value={t('imprint_page.hosting_provider_value')} />
                            <DetailItem label={t('imprint_page.email_label')} value={<a href={`mailto:${t('imprint_page.email_value')}`} className="text-primary hover:underline">{t('imprint_page.email_value')}</a>} />
                        </dl>
                    </div>

                    <div className="mt-12">
                        <h2 className="text-3xl font-bold text-gray-900 text-center border-t border-gray-200 pt-10">
                            {t('imprint_page.banking_info_label')}
                        </h2>
                        <div className="mt-6 border-t border-gray-200 pt-8">
                            <dl className="divide-y divide-gray-200">
                                <DetailItem label={t('imprint_page.bank_name_label')} value={t('imprint_page.bank_name_value')} />
                                <DetailItem label={t('imprint_page.swift_bic_label')} value={t('imprint_page.swift_bic_value')} />
                                <DetailItem label={t('imprint_page.huf_iban_label')} value={t('imprint_page.huf_iban_value')} />
                                <DetailItem label={t('imprint_page.eur_iban_label')} value={t('imprint_page.eur_iban_value')} />
                            </dl>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default Imprint;